/* Stellanacht: sterrenkaart-voorvertoning in de browser.
   Rekent per ster hoogte en azimut uit (Meeus) en projecteert de zichtbare hemel stereografisch.
   Sterrendata: starmap-data.json (uit d3-celestial, BSD-3). Plaatsen via Open-Meteo geocoding.
   Meet: clarity('event','voorvertoning') en fbq('track','CustomizeProduct'). */
(function () {
  const STIJL = {
    nacht: { bg: "#121c33", ink: "#efe9dc", star: "#f6f2e8", line: "#6f7fa6", grid: "#223050", accent: "#c9a24b" },
    papier: { bg: "#f4efe6", ink: "#242b45", star: "#242b45", line: "#9aa1bb", grid: "#e4ded2", accent: "#b8923f" },
    zwart: { bg: "#0d0d10", ink: "#ece7dc", star: "#ffffff", line: "#5c6579", grid: "#1f2129", accent: "#c9a24b" },
    /* Kinder: cremefarbenes Blatt, petrolblauer Himmel, gelbe Sterne, deutsche Sternbildnamen */
    kinder: { bg: "#f7f2e8", sky: "#1f5b70", ink: "#2b3a4a", star: "#f3c653", line: "#8fc3cf", grid: "#2b6a80", accent: "#d9a02b", label: "#f6d473", animal: "#a9d6de", names: true, sans: true, animals: true },
    rose: { bg: "#f3e4de", ink: "#4a3a3e", star: "#9a7a3b", line: "#c7a39c", grid: "#e9d6cf", accent: "#b8923f" },
    wald: { bg: "#13302a", ink: "#ece6d6", star: "#f3ebd6", line: "#5f8f7c", grid: "#1f4238", accent: "#c9a24b" },
    /* Mond: tiefes Nachtblau, die echte Mondphase als Medaillon und, wenn über dem Horizont, am Himmel */
    mond: { bg: "#0f1a2e", ink: "#ece6d6", star: "#f1ead8", line: "#5b6c90", grid: "#1d2a44", accent: "#d8c9a3", moon: "#f1e9d2", moonDark: "#1b2742", moonPhase: true },
    /* Vorlagen: illustrierte Hintergründe (templates/maak_templates.py), Himmel und Text rechnet starmap.js darüber.
       geo = Mittelpunkt x, y und Radius als Anteil der Vorlage (3:4); ty = Höhe der Titelzeile */
    gold: { bg: "#0b1528", ink: "#e2c27c", star: "#f6e2ac", line: "#a8894f", grid: "#1a2643", accent: "#c9a24b", tpl: "https://cdn.shopify.com/s/files/1/1044/2470/2329/files/tpl_gold_v2.jpg?v=1792249839", geo: [0.4991, 0.3999, 0.3995], ty: 0.805 },
    aquarell: { bg: "#0e2432", ink: "#eddcb4", star: "#fbeec8", line: "#cdb47c", grid: "rgba(255,255,255,0.07)", accent: "#d6b66c", tpl: "https://cdn.shopify.com/s/files/1/1044/2470/2329/files/tpl_aquarell_v2.jpg?v=1792249835", geo: [0.4968, 0.399, 0.3944], ty: 0.795 },
    tiere: { bg: "#f7f2e7", sky: "#0c4153", ink: "#1f3f57", accent: "#c79a3c", star: "#f3c653", line: "#8fc3cf", grid: "#2b6a80", label: "#f6d473", animal: "#a9d6de", names: true, sans: true, animals: true, disc: true, tpl: "https://cdn.shopify.com/s/files/1/1044/2470/2329/files/tpl_tiere_v2.jpg?v=1792249851", geo: [0.4966, 0.3655, 0.4161], ty: 0.878, serifTitel: true },
    pastell: { bg: "#f7ece2", sky: "#1e5467", ink: "#6e4424", accent: "#c9965a", star: "#f3c653", line: "#8fc3cf", grid: "#2b6a80", label: "#f6d473", animal: "#a9d6de", names: true, sans: true, animals: true, disc: true, tpl: "https://cdn.shopify.com/s/files/1/1044/2470/2329/files/tpl_pastell_v2.jpg?v=1792249845", geo: [0.4997, 0.4186, 0.389], ty: 0.84, serifTitel: true },
    abenteuer: { bg: "#ecdcc2", sky: "#164c60", ink: "#1d3550", accent: "#c79a3c", star: "#f3c653", line: "#8fc3cf", grid: "#2b6a80", label: "#f6d473", animal: "#a9d6de", names: true, sans: true, animals: true, disc: true, tpl: "https://cdn.shopify.com/s/files/1/1044/2470/2329/files/tpl_abenteuer_v2.jpg?v=1792249829", geo: [0.4978, 0.4067, 0.3369], ty: 0.885, titelVet: true }
  };
  const PHASEN = [[0.03, "Neumond"], [0.22, "zunehmende Sichel"], [0.28, "erstes Viertel"], [0.47, "zunehmender Mond"], [0.53, "Vollmond"], [0.72, "abnehmender Mond"], [0.78, "letztes Viertel"], [0.97, "abnehmende Sichel"], [1.01, "Neumond"]];
  /* Mondpositie en -fase, laag-precies (Meeus hfst. 47, grootste termen; ca. 0,3 graad) */
  function maan(j) {
    const T = (j - 2451545.0) / 36525, rad = Math.PI / 180, s = x => Math.sin(x * rad);
    const Lp = 218.3164477 + 481267.88123421 * T, D = 297.8501921 + 445267.1114034 * T, M = 357.5291092 + 35999.0502909 * T, Mp = 134.9633964 + 477198.8675055 * T, F = 93.2720950 + 483202.0175233 * T;
    const lon = Lp + 6.289 * s(Mp) + 1.274 * s(2 * D - Mp) + 0.658 * s(2 * D) + 0.214 * s(2 * Mp) - 0.186 * s(M) - 0.059 * s(2 * D - 2 * Mp) - 0.057 * s(2 * D - M - Mp) + 0.053 * s(2 * D + Mp) - 0.046 * s(2 * D - M) + 0.041 * s(Mp - M) - 0.035 * s(D) - 0.031 * s(M + Mp);
    const lat = 5.128 * s(F) + 0.281 * s(Mp + F) - 0.278 * s(Mp - F) - 0.173 * s(2 * D - F) + 0.055 * s(2 * D - Mp + F) + 0.046 * s(2 * D - Mp - F) + 0.033 * s(2 * D + F) + 0.017 * s(2 * Mp + F);
    const Ls = 280.46646 + 36000.76983 * T + 1.915 * s(M) + 0.02 * s(2 * M);
    const eps = 23.4393 * rad, l = lon * rad, b = lat * rad;
    const ra = (Math.atan2(Math.sin(l) * Math.cos(eps) - Math.tan(b) * Math.sin(eps), Math.cos(l)) / rad + 360) % 360;
    const dec = Math.asin(Math.sin(b) * Math.cos(eps) + Math.cos(b) * Math.sin(eps) * Math.sin(l)) / rad;
    const elong = ((lon - Ls) % 360 + 360) % 360, fase = elong / 360, licht = (1 - Math.cos(elong * rad)) / 2;
    return { ra, dec, fase, licht, naam: PHASEN.find(p => fase < p[0])[1] };
  }
  function tekenMaan(ctx, x, y, R, m, S) {
    ctx.save(); ctx.beginPath(); ctx.arc(x, y, R, 0, 2 * Math.PI); ctx.clip();
    ctx.fillStyle = S.moon; ctx.fillRect(x - R, y - R, 2 * R, 2 * R);
    const wassend = m.fase < 0.5;
    ctx.fillStyle = S.moonDark; ctx.fillRect(wassend ? x - R : x, y - R, R, 2 * R); /* donkere helft links bij wassende maan */
    ctx.fillStyle = m.licht < 0.5 ? S.moonDark : S.moon;
    ctx.beginPath(); ctx.ellipse(x, y, R * Math.abs(Math.cos(m.fase * 2 * Math.PI)), R, 0, 0, 2 * Math.PI); ctx.fill();
    ctx.restore();
    ctx.strokeStyle = S.accent; ctx.lineWidth = Math.max(0.6, R * 0.04); ctx.beginPath(); ctx.arc(x, y, R, 0, 2 * Math.PI); ctx.stroke();
  }
  let laatsteMaan = null;
  const MAAND = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
  let DATA = null, dataP = null;
  let TIERE = null, tiereP = null; /* Kinder-stijl: CC0-silhouetten van PhyloPic (starmap-tiere.json), getint als masker */
  function laadTiere(url) {
    if (tiereP) return tiereP;
    tiereP = fetch(url).then(r => r.json()).then(d => {
      const klaar = Object.keys(d).map(k => new Promise(res => {
        const img = new Image();
        img.onload = () => { d[k].img = img; res(); }; img.onerror = () => res();
        img.src = d[k].a;
      }));
      return Promise.all(klaar).then(() => (TIERE = d));
    }).catch(() => (TIERE = {}));
    return tiereP;
  }
  function tint(t, kleur) {
    if (t.tinted && t.tintKleur === kleur) return t.tinted;
    const c = document.createElement("canvas"); c.width = t.w; c.height = t.h; const x = c.getContext("2d");
    x.drawImage(t.img, 0, 0); x.globalCompositeOperation = "source-in"; x.fillStyle = kleur; x.fillRect(0, 0, t.w, t.h);
    t.tinted = c; t.tintKleur = kleur; return c;
  }

  const VORLAGE = {}; /* stijl -> Image, geladen bij eerste gebruik */
  function laadVorlage(stijl) {
    const S = STIJL[stijl]; if (!S || !S.tpl) return Promise.resolve();
    if (!VORLAGE[stijl]) VORLAGE[stijl] = new Promise(res => { const img = new Image(); img.crossOrigin = "anonymous"; img.onload = () => res(img); img.onerror = () => res(null); img.src = S.tpl; });
    return VORLAGE[stijl].then(img => { S.img = img; });
  }

  function laad(url) {
    if (!dataP) dataP = fetch(url).then(r => r.json()).then(d => (DATA = d));
    return dataP;
  }
  function jd(dUtc) {
    let y = dUtc.getUTCFullYear(), m = dUtc.getUTCMonth() + 1;
    const d = dUtc.getUTCDate() + (dUtc.getUTCHours() + dUtc.getUTCMinutes() / 60) / 24;
    if (m <= 2) { y -= 1; m += 12; }
    const a = Math.floor(y / 100), b = 2 - a + Math.floor(a / 4);
    return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (m + 1)) + d + b - 1524.5;
  }
  function lst(j, lon) {
    const t = (j - 2451545.0) / 36525;
    const g = 280.46061837 + 360.98564736629 * (j - 2451545.0) + 0.000387933 * t * t - t * t * t / 38710000;
    return (((g + lon) % 360) + 360) % 360;
  }
  function altaz(ra, dec, L, lat) {
    const h = ((L - ra) % 360) * Math.PI / 180, d = dec * Math.PI / 180, f = lat * Math.PI / 180;
    const sa = Math.sin(d) * Math.sin(f) + Math.cos(d) * Math.cos(f) * Math.cos(h);
    const alt = Math.asin(Math.max(-1, Math.min(1, sa)));
    const y = -Math.sin(h) * Math.cos(d), x = Math.sin(d) * Math.cos(f) - Math.cos(d) * Math.sin(f) * Math.cos(h);
    let az = Math.atan2(y, x); if (az < 0) az += 2 * Math.PI;
    return [alt * 180 / Math.PI, az * 180 / Math.PI];
  }
  function proj(alt, az, r) {
    const z = (90 - alt) * Math.PI / 180, rho = r * Math.tan(z / 2), a = az * Math.PI / 180;
    return [-rho * Math.sin(a), -rho * Math.cos(a)];
  }
  /* lokale tijd in een IANA-tijdzone naar UTC */
  function naarUtc(datum, tijd, tz) {
    const [Y, M, D] = datum.split("-").map(Number), [h, mi] = tijd.split(":").map(Number);
    const gok = Date.UTC(Y, M - 1, D, h, mi);
    const fmt = new Intl.DateTimeFormat("en-US", { timeZone: tz, hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    const p = Object.fromEntries(fmt.formatToParts(new Date(gok)).map(x => [x.type, x.value]));
    const alsLokaal = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
    return new Date(gok - (alsLokaal - gok));
  }

  function teken(canvas, o) {
    const S = STIJL[o.stijl] || STIJL.nacht, dik = o.dik || 1;
    const W = canvas.width, H = canvas.height, ctx = canvas.getContext("2d");
    let cx = W / 2, cy = H * 0.42, r = W * 0.36, vy = 0, vh = H;
    ctx.fillStyle = S.bg; ctx.fillRect(0, 0, W, H);
    if (S.tpl) { /* vorlage 3:4 op volle breedte; bij 50 x 70 blijft boven en onder een rand in de achtergrondkleur */
      vh = W * 4 / 3; vy = (H - vh) / 2;
      if (S.img) ctx.drawImage(S.img, 0, vy, W, vh);
      cx = W * S.geo[0]; cy = vy + vh * S.geo[1]; r = W * S.geo[2];
    }
    const L = lst(jd(o.utc), o.lon);
    ctx.save(); ctx.beginPath(); ctx.arc(cx, cy, r, 0, 2 * Math.PI); ctx.clip();
    if (S.sky) { ctx.fillStyle = S.sky; ctx.fillRect(0, 0, W, H); }
    ctx.strokeStyle = S.grid; ctx.lineWidth = Math.max(0.4, W * 0.0005);
    [30, 60].forEach(k => { const rr = r * Math.tan((90 - k) * Math.PI / 360); ctx.beginPath(); ctx.arc(cx, cy, rr, 0, 2 * Math.PI); ctx.stroke(); });
    for (let a = 0; a < 360; a += 45) { const [x, y] = proj(0, a, r); ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + x, cy + y); ctx.stroke(); }
    ctx.strokeStyle = S.line; ctx.lineWidth = Math.max(0.5, W * 0.0007) * dik; ctx.globalAlpha = 0.9;
    let n = 0;
    const namen = [], segmenten = [];
    DATA.l.forEach((c, ci) => {
      let sx = 0, sy = 0, zicht = 0, tot = 0, minx = 1e9, maxx = -1e9, miny = 1e9, maxy = -1e9;
      for (const lijn of c) {
        let prev = null;
        for (const [ra, dec] of lijn) {
          const [alt, az] = altaz(ra, dec, L, o.lat); tot++;
          if (alt > 0) { const [x, y] = proj(alt, az, r); sx += x; sy += y; zicht++; minx = Math.min(minx, x); maxx = Math.max(maxx, x); miny = Math.min(miny, y); maxy = Math.max(maxy, y); }
          if (prev && prev[0] > 0 && alt > 0) {
            const [x1, y1] = proj(prev[0], prev[1], r), [x2, y2] = proj(alt, az, r);
            segmenten.push([cx + x1, cy + y1, cx + x2, cy + y2]);
          }
          prev = [alt, az];
        }
      }
      if (S.names && DATA.n && zicht >= 3 && zicht / tot >= 0.6) {
        const id = DATA.i ? DATA.i[ci] : null, t = (S.animals && TIERE && id && TIERE[id] && TIERE[id].img) ? TIERE[id] : null;
        let labelY = cy + sy / zicht;
        if (t) {
          /* silhouet in de omhullende van het sternbeeld, zacht getint, achter lijnen en sterren */
          const bw = Math.max(r * 0.14, Math.min(r * 0.55, (maxx - minx) * 1.15)), bh = Math.max(r * 0.12, Math.min(r * 0.5, (maxy - miny) * 1.15));
          const sc = Math.min(bw / t.w, bh / t.h), w = t.w * sc, h = t.h * sc, x0 = cx + sx / zicht - w / 2, y0 = cy + sy / zicht - h / 2;
          ctx.globalAlpha = 0.55; ctx.drawImage(tint(t, S.animal || S.line), x0, y0, w, h); ctx.globalAlpha = 1;
          labelY = y0 + h + W * 0.012;
        }
        namen.push([cx + sx / zicht, labelY, DATA.n[ci]]);
      }
    });
    for (const [x1, y1, x2, y2] of segmenten) { ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke(); }
    ctx.globalAlpha = 1; ctx.fillStyle = S.star;
    for (const [ra, dec, mag] of DATA.s) {
      if (mag > 5.0) continue;
      const [alt, az] = altaz(ra, dec, L, o.lat);
      if (alt <= 0) continue; n++;
      const [x, y] = proj(alt, az, r), rad = (W * 0.0019 * (1 - (mag + 1.5) / 7) + W * 0.00025) * (S.tpl ? 1.45 : 1) * dik;
      if (mag < 2) { ctx.globalAlpha = 0.14; ctx.beginPath(); ctx.arc(cx + x, cy + y, rad * 2.6, 0, 2 * Math.PI); ctx.fill(); ctx.globalAlpha = 1; }
      ctx.beginPath(); ctx.arc(cx + x, cy + y, rad, 0, 2 * Math.PI); ctx.fill();
    }
    if (namen.length) {
      ctx.fillStyle = S.label || S.ink; ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.font = `600 ${W * 0.0125}px "Avenir Next", "Helvetica Neue", Arial, sans-serif`;
      const bezet = [];
      for (const [x, y, t] of namen) {
        const w = ctx.measureText(t).width, h = W * 0.016;
        if (bezet.some(b => Math.abs(b[0] - x) < (b[2] + w) / 2 + 4 && Math.abs(b[1] - y) < h)) continue;
        ctx.globalAlpha = 0.5; ctx.fillStyle = S.sky || S.bg; ctx.fillRect(x - w / 2 - 3, y - h / 2, w + 6, h); ctx.globalAlpha = 1;
        ctx.fillStyle = S.label || S.ink; ctx.fillText(t, x, y); bezet.push([x, y, w]);
      }
      ctx.textBaseline = "alphabetic";
    }
    laatsteMaan = null;
    if (S.moonPhase) {
      const m = maan(jd(o.utc)); laatsteMaan = m;
      const [malt, maz] = altaz(m.ra, m.dec, L, o.lat); m.boven = malt > 0;
      if (m.boven) { const [mx, my] = proj(malt, maz, r); tekenMaan(ctx, cx + mx, cy + my, r * 0.04, m, S); }
    }
    ctx.restore();
    if (S.moonPhase && laatsteMaan) {
      const R = W * 0.055, mx = W * 0.86, my = H * 0.11;
      tekenMaan(ctx, mx, my, R, laatsteMaan, S);
      ctx.fillStyle = S.accent; ctx.textAlign = "center"; ctx.textBaseline = "top";
      ctx.font = `${W * 0.015}px Baskerville, 'Libre Baskerville', Georgia, serif`;
      ctx.fillText(laatsteMaan.naam, mx, my + R + W * 0.012);
      ctx.fillText(`${Math.round(laatsteMaan.licht * 100)} % beleuchtet${laatsteMaan.boven ? "" : " · unter dem Horizont"}`, mx, my + R + W * 0.032);
      ctx.textBaseline = "alphabetic";
    }
    if (S.tpl) { /* vorlagen: één dunne gouden rand, zoals in het ontwerp */
      ctx.strokeStyle = S.accent; ctx.lineWidth = Math.max(0.8, W * 0.0012); ctx.beginPath(); ctx.arc(cx, cy, S.disc ? r * 1.03 : r, 0, 2 * Math.PI); ctx.stroke();
    } else {
      ctx.strokeStyle = S.ink; ctx.lineWidth = Math.max(0.8, W * 0.0009); ctx.beginPath(); ctx.arc(cx, cy, r, 0, 2 * Math.PI); ctx.stroke();
      ctx.strokeStyle = S.accent; ctx.lineWidth = Math.max(0.6, W * 0.0006); ctx.beginPath(); ctx.arc(cx, cy, r * 1.035, 0, 2 * Math.PI); ctx.stroke();
    }
    const serif = (S.sans && !S.serifTitel) || S.titelVet ? "'Avenir Next', 'Helvetica Neue', Arial, sans-serif" : "Baskerville, 'Libre Baskerville', Georgia, 'Times New Roman', serif";
    ctx.fillStyle = S.accent; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.font = `${W * 0.016}px ${serif}`;
    [[0, "N"], [90, "O"], [180, "S"], [270, "W"]].forEach(([a, t]) => { const [x, y] = proj(-6, a, r * 1.035); ctx.fillText(t, cx + x, cy + y); });
    ctx.textBaseline = "alphabetic";
    const fs = W * (S.titelVet ? 0.03 : 0.034), ty = S.ty ? vy + vh * S.ty : H * 0.845, tx = W / 2;
    ctx.fillStyle = S.ink; ctx.font = `${S.titelVet ? "600 " : ""}${fs}px ${serif}`; ctx.fillText(o.titel, tx, ty);
    ctx.strokeStyle = S.accent; ctx.lineWidth = Math.max(0.8, W * 0.0008); ctx.beginPath(); ctx.moveTo(tx - W * 0.04, ty + fs * 0.9); ctx.lineTo(tx + W * 0.04, ty + fs * 0.9); ctx.stroke();
    ctx.font = `${fs * 0.46}px ${serif}`; ctx.fillText(o.regel, tx, ty + fs * 2.0);
    if (o.regel2) { ctx.globalAlpha = 0.7; ctx.font = `${fs * 0.38}px ${serif}`; ctx.fillText(o.regel2, tx, ty + fs * 2.9); ctx.globalAlpha = 1; }
    return n;
  }

  function init(root) {
    const $ = s => root.querySelector(s);
    const plaats = $(".sn-plaats"), lijst = $(".sn-suggesties"), datum = $(".sn-datum"), tijd = $(".sn-tijd"), titel = $(".sn-titel");
    const canvas = $(".sn-canvas"), info = $(".sn-info"), stage = $(".sn-stage"), knop = $(".sn-bestel");
    const formats = root.querySelectorAll(".sn-format"), frame = $(".sn-frame"), note = $(".sn-note"), prijs = $(".sn-prijs");
    const laden = $(".sn-laden"), ladenTekst = $(".sn-laden-tekst");
    const sticky = $(".sn-sticky"), stickyKnop = $(".sn-sticky-knop"), stickyPrijs = $(".sn-sticky-prijs"), meer = $(".sn-meer");
    const rustig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const stappen = root.classList.contains("sn-preview--stappen");
    const voortgangT = $(".sn-voortgang-t"), weiter = $(".sn-weiter"), terug = $(".sn-terug"), fout = $(".sn-fout"), datumVeld = $(".sn-veld--datum");
    const klaarBlok = $(".sn-klaar"), samT = $(".sn-sam-t"), wijzig = $(".sn-wijzig"), koop = $(".sn-koop"), anpassen = $(".sn-anpassen"), anpassenKeuze = $(".sn-anpassen-keuze");
    const tijdToggle = $(".sn-tijd-toggle"), tijdVeld = $(".sn-veld--tijd"), punten = root.querySelectorAll(".sn-punt");
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) root.classList.add("sn-ios");
    const vandaagIso = new Date().toISOString().slice(0, 10), dv = () => datum.value || vandaagIso; /* zonder eigen datum: voorbeeldkaart van vandaag */
    let wstap = 1, ortGekozen = !stappen, stickyUpd = () => {}, doorTimer = null, laatsteRes = [];
    let ladenTimers = [];
    /* korte "wordt berekend"-sequentie na een echte wijziging; de kaart is intussen al getekend */
    function toonLaden(n) {
      if (!laden) return;
      ladenTimers.forEach(clearTimeout); ladenTimers = [];
      stage.classList.remove("sn-stage--klaar"); laden.hidden = false;
      const stappen = rustig ? [[0, "Eure Karte wird berechnet …"]] :
        [[0, "Sterne werden berechnet …"], [750, `Himmel über ${gekozen.name} berechnet`], [1400, "Eure Karte ist fertig"]];
      stappen.forEach(([t, tekst]) => ladenTimers.push(setTimeout(() => { ladenTekst.textContent = tekst; }, t)));
      ladenTimers.push(setTimeout(() => { laden.hidden = true; stage.classList.add("sn-stage--klaar"); }, rustig ? 600 : 1950));
    }
    const NOTE = { framed: "So kommt sie bei dir an: 30 x 40 cm, schwarzer Holzrahmen, Plexiglas, fertig zum Aufhängen.",
                   poster: "So kommt sie bei dir an: 50 x 70 cm auf 200 g mattem Papier, gerollt im stabilen Karton, ohne Rahmen.",
                   set: "So kommt es bei dir an: zwei Karten 30 x 40 cm derselben Nacht, schwarzer Holzrahmen, fertig zum Aufhängen." };
    let fmt = null;
    const dataUrl = root.dataset.data;
    const BERLIN = { name: "Berlin", country: "Deutschland", country_code: "DE", latitude: 52.52, longitude: 13.405, timezone: "Europe/Berlin" };
    let gekozen = BERLIN, stijl = root.dataset.stijl || "nacht", timer = null, gemeten = false, stijlGekozen = false, tekstGekozen = false;
    const stijlVast = !!root.dataset.stijl, tekstVast = root.dataset.tekstVast === "true";
    root.querySelectorAll("[data-stijl]").forEach(x => x.setAttribute("aria-pressed", String(x.dataset.stijl === stijl)));
    let bewaard = null; try { bewaard = JSON.parse(sessionStorage.getItem("sn-config") || "null"); } catch (e) {}
    function bewaar() { try { sessionStorage.setItem("sn-config", JSON.stringify({ gekozen, ortGekozen, wstap, pad: location.pathname, plaats: plaats.value, datum: datum.value, tijd: tijd.value, titel: titel.value, tekstGekozen, stijl, stijlGekozen, framed: fmt ? fmt.framed : true, big: fmt ? fmt.big : false, oak: fmt ? fmt.oak : false, fineart: fmt ? fmt.fineart : false })); } catch (e) {} }
    const varianten = Array.from(formats).map(b => ({ id: b.dataset.id || null, framed: b.dataset.framed === "true", big: b.dataset.big === "true", set: b.dataset.set === "true",
      oak: b.dataset.oak === "true", fineart: b.dataset.fineart === "true", cents: +(b.dataset.cents || 0), link: b.dataset.link || null, price: b.dataset.price || "" }));
    const groepVan = v => (v.set ? "set" : (v.big ? "50" : "30") + (v.framed ? "-gerahmt" : "-poster"));
    const GROEP = { "30-gerahmt": "30 x 40 cm, gerahmt", "30-poster": "30 x 40 cm, ohne Rahmen", "50-gerahmt": "50 x 70 cm, gerahmt", "50-poster": "50 x 70 cm, ohne Rahmen", set: "Set für zwei, 2 x 30 x 40 cm, gerahmt" };
    const VOLGORDE = ["30-gerahmt", "30-poster", "50-gerahmt", "50-poster", "set"];
    const ausfLabel = v => v.oak ? "Eiche natur, Premium" : v.fineart ? "Fine-Art-Druck, 12 Farben" : (v.framed ? "Kiefer schwarz, Premium matt" : "Premium matt, 200 g");
    const ausfSub = v => v.oak ? "Massivholz 20\u00a0mm, Museum-Papier 250\u00a0g" : v.fineart ? "Giclée-Druck, tiefere Farben, 200\u00a0g matt" : (v.framed ? "Holzrahmen mit Plexiglas, Papier 200\u00a0g" : "Mattes Papier 200\u00a0g, ohne Rahmen");
    const euro = c => "€" + (c / 100).toFixed(2).replace(".", ",");
    const formaatBox = $(".sn-formaten"), ausfBox = $(".sn-ausf"), ausfStap = $(".sn-stap--ausf");
    function notitie(v) {
      const maat = v.big ? "50 x 70 cm" : "30 x 40 cm";
      if (!v.framed) return `So kommt sie bei dir an: ${maat} auf 200 g mattem Papier${v.fineart ? " (Fine-Art-Druck, 12 Farben)" : ""}, ohne Rahmen, ${v.big ? "gerollt im stabilen Karton" : "sicher verpackt"}.`;
      return `So kommt ${v.set ? "es" : "sie"} bei dir an: ${v.set ? "zwei Karten " : ""}${maat}, ${v.oak ? "Rahmen aus Eiche natur (20 mm), Museum-Papier 250 g" : "schwarzer Holzrahmen"}, Plexiglas, fertig zum Aufhängen${v.fineart ? ", Fine-Art-Druck mit 12 Farben" : ""}.`;
    }
    function kiesVariant(v, interactie) {
      fmt = v;
      formats.forEach(x => x.setAttribute("aria-pressed", String((x.dataset.id || x.dataset.link) === (v.id || v.link))));
      canvas.width = 900; canvas.height = v.big ? 1260 : 1200; /* 30x40 = 3:4, 50x70 = 5:7, zoals Gelato drukt */
      if (frame) { frame.classList.toggle("sn-frame--poster", !v.framed); frame.classList.toggle("sn-frame--eiche", !!v.oak); }
      if (note) note.textContent = notitie(v);
      if (prijs && v.price) prijs.textContent = v.price;
      if (stickyPrijs && v.price) stickyPrijs.textContent = v.price;
      if (knop && v.link) knop.setAttribute("href", v.link);
      bouwAusf(groepVan(v), v);
      keuzeUpd();
      render(interactie);
    }
    function bouwAusf(groep, actief) {
      if (!ausfBox) return;
      const lijst = varianten.filter(v => groepVan(v) === groep).sort((a, b) => a.cents - b.cents);
      const basis = lijst.length ? lijst[0].cents : 0;
      ausfBox.innerHTML = "";
      lijst.forEach(v => {
        const b = document.createElement("button"); b.type = "button"; b.className = "sn-format"; b.setAttribute("aria-pressed", String(v === actief));
        b.innerHTML = `<span class="sn-format-t">${ausfLabel(v)}<small>${ausfSub(v)}</small></span><span class="sn-format-p">${v.cents > basis ? "+ " + euro(v.cents - basis) : "inklusive"}</span>`;
        b.addEventListener("click", () => kiesVariant(v, true)); ausfBox.appendChild(b);
      });
      if (ausfStap) ausfStap.hidden = lijst.length < 2;
    }
    function bouwFormaten(actiefGroep) {
      if (!formaatBox) return;
      const groepen = []; varianten.forEach(v => { const g = groepVan(v); if (!groepen.includes(g)) groepen.push(g); });
      groepen.sort((a, b) => VOLGORDE.indexOf(a) - VOLGORDE.indexOf(b));
      formaatBox.innerHTML = "";
      groepen.forEach(g => {
        const basis = varianten.filter(v => groepVan(v) === g).sort((a, b) => a.cents - b.cents)[0];
        const b = document.createElement("button"); b.type = "button"; b.className = "sn-format"; b.dataset.groep = g; b.setAttribute("aria-pressed", String(g === actiefGroep));
        b.innerHTML = `<span class="sn-mini"><canvas width="240" height="180" aria-hidden="true"></canvas></span><span class="sn-format-t">${GROEP[g]}</span><span class="sn-format-p">${groepen.length > 1 && basis.cents ? "ab " + basis.price : basis.price}</span>`;
        b.addEventListener("click", () => { formaatBox.querySelectorAll(".sn-format").forEach(x => x.setAttribute("aria-pressed", String(x === b))); kiesVariant(basis, true); });
        formaatBox.appendChild(b);
      });
      tekenMinis();
    }
    /* kleine sfeerbeelden per formaat: wand, de kaart op schaal (30x40 tegenover 50x70), met of zonder lijst */
    function tekenMinis() {
      if (!formaatBox) return;
      formaatBox.querySelectorAll(".sn-format").forEach(b => {
        const c = b.querySelector("canvas"); if (!c) return;
        const g = b.dataset.groep, groot = g.startsWith("50"), lijst = g !== "30-poster" && g !== "50-poster", set = g === "set";
        const x = c.getContext("2d"), W = c.width, H = c.height;
        x.clearRect(0, 0, W, H);
        x.fillStyle = "#F1ECE4"; x.fillRect(0, 0, W, H);
        x.fillStyle = "#E4DDD2"; x.fillRect(0, H - 14, W, 14); /* plint/vloerlijn als maatreferentie */
        const h = groot ? 132 : 76, w = groot ? Math.round(h * 5 / 7) : Math.round(h * 3 / 4), rand = lijst ? 4 : 0;
        const teken1 = (cx) => {
          const px = Math.round(cx - w / 2), py = H - 14 - 10 - h;
          x.save(); x.shadowColor = "rgba(0,0,0,.28)"; x.shadowBlur = lijst ? 10 : 6; x.shadowOffsetY = lijst ? 4 : 2;
          x.fillStyle = lijst ? (!set && fmt && fmt.oak ? "#d2a87d" : "#111111") : "#FFFFFF"; x.fillRect(px - rand, py - rand, w + rand * 2, h + rand * 2); x.restore();
          if (canvas.width) x.drawImage(canvas, px, py, w, h);
          if (!lijst) { x.strokeStyle = "rgba(0,0,0,.12)"; x.lineWidth = 1; x.strokeRect(px + .5, py + .5, w - 1, h - 1); }
        };
        if (set) { teken1(W / 2 - w / 2 - 6); teken1(W / 2 + w / 2 + 6); } else teken1(W / 2);
      });
    }
    function kiesFormat(b, interactie) { /* variantknop -> groepen bouwen en variant kiezen */
      const v = varianten[Array.from(formats).indexOf(b)]; if (!v) return;
      bouwFormaten(groepVan(v)); kiesVariant(v, interactie);
    }
    canvas.width = 900; canvas.height = 1200;

    function regel() {
      if (!gekozen) return "";
      const [Y, M, D] = dv().split("-").map(Number);
      return `${gekozen.name}  ·  ${D}. ${MAAND[M - 1]} ${Y}` + (tijd.value ? `  ·  ${tijd.value}` : "");
    }
    function coords() {
      if (!gekozen) return "";
      const la = gekozen.latitude, lo = gekozen.longitude;
      return `${Math.abs(la).toFixed(2)}° ${la >= 0 ? "N" : "S"}   ${Math.abs(lo).toFixed(2)}° ${lo >= 0 ? "O" : "W"}`;
    }
    function render(interactie, metLaden) {
      if (!gekozen) return;
      if (interactie) bewaar();
      const extra = (STIJL[stijl] && STIJL[stijl].animals && root.dataset.tiere) ? laadTiere(root.dataset.tiere) : Promise.resolve();
      Promise.all([laad(dataUrl), extra, laadVorlage(stijl)]).then(() => {
        const utc = naarUtc(dv(), tijd.value || "22:00", gekozen.timezone || "Europe/Berlin");
        const dik = Math.min(2.6, Math.max(1, 420 / (canvas.clientWidth || 420))); /* klein op het scherm: sterren en lijnen dikker, zoals op de print */
        const n = teken(canvas, { utc, lat: gekozen.latitude, lon: gekozen.longitude, stijl, titel: titel.value || "", regel: regel(), regel2: coords(), dik });
        stage.hidden = false;
        info.textContent = `Echte Sternpositionen über ${gekozen.name} · Hipparcos-Katalog der ESA` + (laatsteMaan ? ` · Mond: ${laatsteMaan.naam}, ${Math.round(laatsteMaan.licht * 100)} % beleuchtet` : "");
        if (metLaden) toonLaden(n);
        tekenMinis();
        if (interactie && !gemeten) {
          gemeten = true;
          try { if (window.clarity) clarity("event", "voorvertoning"); } catch (e) {}
          try { if (window.fbq) fbq("track", "CustomizeProduct", { content_name: "sterrenkaart" }); } catch (e) {}
        }
      });
    }
    function kiesPlaats(p) {
      gekozen = p; ortGekozen = true; plaats.value = p.name + (p.country ? ", " + p.country : "");
      lijst.hidden = true; meld(""); render(true, true);
    }
    function zoek(q) {
      if (q.length < 2) { lijst.hidden = true; laatsteRes = []; return Promise.resolve([]); }
      return fetch(`https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(q)}&count=6&language=de&format=json`)
        .then(r => r.json()).then(d => {
          const VOOR = { DE: 0, AT: 1, CH: 2 };
          const res = (d.results || []).slice().sort((a, b) => ((a.country_code in VOOR) ? VOOR[a.country_code] : 9) - ((b.country_code in VOOR) ? VOOR[b.country_code] : 9));
          laatsteRes = res;
          lijst.innerHTML = res.map((p, i) => `<li><button type="button" data-i="${i}">${p.name}${p.admin1 ? ", " + p.admin1 : ""}, ${p.country || ""}</button></li>`).join("");
          lijst.hidden = res.length === 0;
          lijst.querySelectorAll("button").forEach(b => b.addEventListener("click", () => {
            kiesPlaats(res[+b.dataset.i]);
            if (stappen && wstap === 2) { clearTimeout(doorTimer); doorTimer = setTimeout(() => { if (wstap === 2) volgende(false); }, rustig ? 700 : 2100); }
          }));
          return res;
        }).catch(() => { lijst.hidden = true; return []; });
    }
    plaats.addEventListener("input", () => { gekozen = null; ortGekozen = false; laatsteRes = []; clearTimeout(timer); timer = setTimeout(() => zoek(plaats.value.trim()), 250); });
    let dtTimer = null;
    [datum, tijd].forEach(el => el.addEventListener("input", () => { clearTimeout(dtTimer); dtTimer = setTimeout(() => render(true, true), 500); }));
    titel.addEventListener("input", () => { tekstGekozen = true; render(true); });
    root.querySelectorAll("[data-stijl]").forEach(b => b.addEventListener("click", () => {
      stijl = b.dataset.stijl; stijlGekozen = true; root.querySelectorAll("[data-stijl]").forEach(x => x.setAttribute("aria-pressed", x === b)); render(true); keuzeUpd();
    }));
    if (knop) knop.addEventListener("click", (e) => {
      const form = document.querySelector('form[action*="/cart/add"]');
      const vid = (fmt && fmt.id) || (form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null);
      bewaar();
      if (!vid || !gekozen) return; /* geen productpagina of nog geen kaart: gewone link, invoer reist mee */
      e.preventDefault();
      const [Yd, Md, Dd] = datum.value.split("-").map(Number);
      const stijlKnop = root.querySelector('.sn-tabs [data-stijl="' + stijl + '"]');
      const props = { "Ort": plaats.value, "Datum": `${Dd}. ${MAAND[Md - 1]} ${Yd}`, "Uhrzeit": tijd.value || "22:00", "Koordinaten": coords(), "Titel": titel.value || "", "Stil": stijlKnop ? stijlKnop.textContent.trim() : stijl };
      try { /* eigen kaart als foto in winkelwagen en kassa (sn-extra.liquid) */
        const t = document.createElement("canvas"); t.width = 300; t.height = Math.round(300 * canvas.height / canvas.width);
        t.getContext("2d").drawImage(canvas, 0, 0, t.width, t.height);
        const sl = "sn-vb:" + [props.Ort, props.Datum, props.Uhrzeit, props.Titel, props.Stil].join("|");
        localStorage.setItem(sl, t.toDataURL("image/jpeg", 0.82));
        let lijstVb = []; try { lijstVb = JSON.parse(localStorage.getItem("sn-vb-lijst") || "[]"); } catch (x) {}
        lijstVb = lijstVb.filter(k => k !== sl); lijstVb.push(sl);
        while (lijstVb.length > 8) localStorage.removeItem(lijstVb.shift());
        localStorage.setItem("sn-vb-lijst", JSON.stringify(lijstVb));
      } catch (x) {}
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: +vid, quantity: 1, properties: props }) })
        .then(() => { try { if (window.fbq) fbq("track", "AddToCart"); } catch (x) {} window.location.href = "/cart"; })
        .catch(() => { window.location.href = "#MainContent"; });
    });
    if (!stappen && !datum.value) datum.value = vandaagIso;
    if (bewaard && bewaard.gekozen) {
      const eigenOrt = !stappen || bewaard.ortGekozen;
      gekozen = eigenOrt ? bewaard.gekozen : BERLIN; ortGekozen = !!eigenOrt; if (eigenOrt) plaats.value = bewaard.plaats || plaats.value;
      if (bewaard.datum) datum.value = bewaard.datum; if (bewaard.tijd) tijd.value = bewaard.tijd;
      if (typeof bewaard.titel === "string" && bewaard.tekstGekozen && (!tekstVast || bewaard.pad === location.pathname)) titel.value = bewaard.titel;
      if (bewaard.stijl && bewaard.stijlGekozen && !stijlVast && STIJL[bewaard.stijl]) { stijl = bewaard.stijl; root.querySelectorAll("[data-stijl]").forEach(x => x.setAttribute("aria-pressed", x.dataset.stijl === stijl)); }
    }
    /* stijlen: per productsoort de passende eerst, de rest achter "Mehr Stile anzeigen"; de gekozen stijl blijft altijd zichtbaar */
    const HOOFD = { liebe: ["nacht", "papier", "zwart", "gold", "aquarell", "rose"], geburt: ["kinder", "tiere", "abenteuer", "pastell", "mond", "papier"] };
    const hoofd = HOOFD[root.dataset.groep] || HOOFD.liebe;
    let alleStijlen = false;
    function stijlZicht() {
      let extra = 0;
      root.querySelectorAll(".sn-tabs [data-stijl]").forEach(b => {
        const toon = alleStijlen || hoofd.includes(b.dataset.stijl) || b.dataset.stijl === stijl;
        b.classList.toggle("sn-stijl-extra", !toon); if (!toon) extra++;
      });
      if (meer) meer.hidden = alleStijlen || extra === 0;
    }
    if (meer) meer.addEventListener("click", () => { alleStijlen = true; meer.setAttribute("aria-expanded", "true"); stijlZicht(); });
    stijlZicht();
    /* mobiel: vaste balk met prijs en bestelknop zodra de kaart uit beeld is en de echte knop nog niet in beeld */
    if (stappen && sticky) {
      let knopZicht = false;
      stickyUpd = () => { sticky.hidden = wstap === 4 && knopZicht; };
      if (knop && "IntersectionObserver" in window) new IntersectionObserver(es => es.forEach(e => { knopZicht = e.intersectionRatio >= 0.9; stickyUpd(); }), { threshold: [0, 0.9, 1] }).observe(knop);
      if (stickyKnop) stickyKnop.addEventListener("click", () => { if (wstap < 4) volgende(true); else if (knop) knop.click(); });
      if (window.matchMedia && window.matchMedia("(max-width: 749px)").matches) document.body.style.paddingBottom = "7.6rem";
    } else if (sticky && knop && "IntersectionObserver" in window) {
      let knopZicht = false, voorbij = false;
      const upd = () => { sticky.hidden = knopZicht || !voorbij; };
      new IntersectionObserver(es => es.forEach(e => { knopZicht = e.isIntersecting; upd(); })).observe(knop);
      new IntersectionObserver(es => es.forEach(e => { voorbij = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); })).observe(stage);
      if (stickyKnop) stickyKnop.addEventListener("click", () => knop.click());
      if (window.matchMedia && window.matchMedia("(max-width: 749px)").matches) document.body.style.paddingBottom = "7.6rem";
    }
    /* stappen: één vraag per keer; na elke invoer verandert de kaart en komt de volgende vraag */
    function meld(t) { if (fout) { fout.textContent = t || ""; fout.hidden = !t; } }
    function clarityStap(naam) { try { if (window.clarity) clarity("event", naam); } catch (e) {} }
    function datumTekst() { const [Y, M, D] = dv().split("-").map(Number); return `${D}. ${MAAND[M - 1]} ${Y}`; }
    function keuzeUpd() {
      if (!anpassenKeuze) return;
      const sk = root.querySelector('.sn-tabs [data-stijl="' + stijl + '"]');
      anpassenKeuze.textContent = [sk ? sk.textContent.trim() : "", fmt ? GROEP[groepVan(fmt)] : "", fmt && (fmt.framed || fmt.fineart) ? ausfLabel(fmt) : ""].filter(Boolean).join(" · ");
    }
    function toonStap(n) {
      if (!stappen) return;
      clearTimeout(doorTimer); meld("");
      wstap = n; root.dataset.wstap = String(n);
      root.querySelectorAll(".sn-wstap").forEach(el => { el.hidden = +el.dataset.wstap !== n; });
      if (voortgangT) voortgangT.textContent = n < 4 ? `Schritt ${n} von 3` : "";
      punten.forEach(p => { p.disabled = +p.dataset.naar >= n; });
      if (weiter) { weiter.textContent = n === 3 ? "Fertig" : "Weiter"; weiter.parentElement.hidden = n === 4; }
      if (terug) terug.hidden = n === 1 || n === 4;
      if (klaarBlok) klaarBlok.hidden = n !== 4;
      if (koop) koop.hidden = n !== 4;
      if (anpassen) anpassen.hidden = n !== 4;
      if (n === 4 && samT) samT.textContent = `${gekozen ? gekozen.name : ""} · ${datumTekst()} · ${tijd.value || "22:00"} Uhr · „${titel.value}“`;
      if (stickyKnop) stickyKnop.textContent = n < 4 ? (n === 3 ? "Fertig" : "Weiter") : (knop ? knop.textContent.trim() : "In den Warenkorb");
      keuzeUpd(); stickyUpd(); bewaar();
    }
    function volgende(viaKlik) {
      if (wstap === 1) {
        if (!datum.value) {
          meld("Bitte wähle ein Datum.");
          try { if (viaKlik && datum.showPicker) datum.showPicker(); else datum.focus(); } catch (e) { datum.focus(); }
          return;
        }
        clarityStap("stap_datum"); toonStap(2); if (viaKlik) plaats.focus();
      } else if (wstap === 2) {
        if (!ortGekozen) {
          const q = plaats.value.trim();
          if (q.length < 2) { meld("Bitte gib einen Ort ein."); plaats.focus(); return; }
          (laatsteRes.length ? Promise.resolve(laatsteRes) : zoek(q)).then(res => {
            if (!res.length) { meld("Diesen Ort finden wir nicht. Versuch es mit der nächsten Stadt."); return; }
            kiesPlaats(res[0]); clarityStap("stap_ort"); toonStap(3);
          });
          return;
        }
        clarityStap("stap_ort"); toonStap(3); if (viaKlik) titel.focus();
      } else if (wstap === 3) {
        clarityStap("stap_tekst"); titel.blur(); toonStap(4); render(true, true);
        if (window.matchMedia && window.matchMedia("(max-width: 749px)").matches) root.scrollIntoView({ block: "start", behavior: rustig ? "auto" : "smooth" });
      }
    }
    if (stappen) {
      const leeg = () => { if (datumVeld) datumVeld.classList.toggle("sn-leeg", !datum.value); };
      datum.addEventListener("input", leeg);
      /* niet vanzelf door na de datum: iOS vult al een datum in zodra je op het veld tikt, de bezoeker kiest zelf Weiter */
      datum.addEventListener("change", () => { leeg(); if (datum.value) meld(""); });
      [datum, plaats, titel].forEach(el => el.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); volgende(true); } }));
      if (weiter) weiter.addEventListener("click", () => volgende(true));
      if (terug) terug.addEventListener("click", () => toonStap(Math.max(1, wstap - 1)));
      punten.forEach(p => p.addEventListener("click", () => { if (+p.dataset.naar < wstap) toonStap(+p.dataset.naar); }));
      if (wijzig) wijzig.addEventListener("click", () => toonStap(1));
      if (tijdToggle && tijdVeld) tijdToggle.addEventListener("click", () => { tijdVeld.hidden = false; tijdToggle.hidden = true; tijdToggle.setAttribute("aria-expanded", "true"); tijd.focus(); });
      if (tijd.value && tijd.value !== "22:00" && tijdVeld) { tijdVeld.hidden = false; if (tijdToggle) tijdToggle.hidden = true; }
      leeg();
      toonStap(bewaard && bewaard.wstap === 4 && bewaard.pad === location.pathname && datum.value && ortGekozen ? 4 : 1); /* terug op dezelfde pagina: direct de klare kaart */
    }
    if (formats.length) {
      let keuze = formats[0];
      if (bewaard && typeof bewaard.big === "boolean") {
        let best = -1;
        formats.forEach(b => { let sc = ((b.dataset.big === "true") === bewaard.big ? 2 : 0) + (typeof bewaard.framed === "boolean" && (b.dataset.framed === "true") === bewaard.framed ? 2 : 0) + (bewaard.oak && b.dataset.oak === "true" ? 1 : 0) + ((b.dataset.fineart === "true") === !!bewaard.fineart ? 1 : 0); if (sc > best) { best = sc; keuze = b; } });
      }
      kiesFormat(keuze, false);
    } else render(false);
  }
  document.querySelectorAll(".sn-preview").forEach(init);
})();
